import React from 'react';

const Idea: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <svg
      version="1.1"
      id="Idea"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 141.73 141.73"
      xmlSpace="preserve"
    >
      <path
        className="st0"
        d="M70.87,44.77c10.27,0,18.62,8.35,18.62,18.62c0,1.98-0.31,3.92-0.91,5.77c-0.89,2.73-2.53,5.76-4.27,8.97
	c-2.26,4.17-4.73,8.72-6.01,13.62H64.01c-1.31-4.96-3.95-9.52-6.37-13.69c-1.84-3.17-3.57-6.17-4.45-8.81
	c-0.75-2.25-1.05-4.61-0.9-7.03c0.58-9.65,8.63-17.31,18.32-17.45C70.69,44.77,70.78,44.77,70.87,44.77 M70.87,37.83
	c-0.12,0-0.24,0-0.36,0C57.23,38.02,46.16,48.55,45.36,61.8c-0.2,3.38,0.25,6.63,1.24,9.63c2.83,8.53,11.29,17.41,11.29,26.4v0.86
	h26.43v-0.36c0-9.19,7.99-18.27,10.84-27.02c0.81-2.49,1.25-5.15,1.25-7.92C96.42,49.27,84.98,37.83,70.87,37.83L70.87,37.83z
	 M84.33,105.25H57.9v6.93h26.43V105.25z M78.54,118.76H63.68v6.93h14.86V118.76z M38.38,59.92H23.52v6.93h14.86V59.92z M44.47,44.14
	L31.6,36.71l-3.47,6.01L41,50.14L44.47,44.14z M57.63,33.52l-7.43-12.87l-6.01,3.47l7.43,12.87L57.63,33.52z M74.33,30.9V16.04H67.4
	V30.9H74.33z M90.11,36.98l7.43-12.87l-6.01-3.47l-7.43,12.87L90.11,36.98z M100.73,50.14l12.87-7.43l-3.47-6.01l-12.87,7.43
	L100.73,50.14z M103.35,66.85h14.86v-6.93h-14.86V66.85z M97.27,82.63l12.87,7.43l3.47-6.01l-12.87-7.43L97.27,82.63z M41,76.62
	l-12.87,7.43l3.47,6.01l12.87-7.43L41,76.62z M118.21,59.92h-14.86v6.93h14.86V59.92z M74.33,30.9V16.04H67.4V30.9H74.33z"
      />
    </svg>
  );
};
export default Idea;
